import { createContext, useMemo, useReducer } from 'react';

import { initialState } from './store/CartStore';
import { cartReducer } from './reducer/CartReducer';
import { ProductService } from '../services/ProductService';
import { globalErrorHandler } from '../utils/errorHandler';
import { useLoader } from '../customHooks/loader';
import { ADD_CART } from '../constants';
import { toast } from 'react-toastify';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, initialState);
  const loader = useLoader();

  const checkAndAddCart = (skuId) => {
    try {

      ProductService.getStockAvailability(
        skuId,
        handleStockFetchSuccess,
        globalErrorHandler,
        loader
      )

    } catch (error) {
      console.log(error);

    }
  }

  const handleStockFetchSuccess = ({ data }) => {
    if (data.data.stock > 0) dispatch({ type: ADD_CART, payload: { skuId: data.data.skuId } });
    else toast.error("Stock not available, please check back later");
  }

  const cartProviderValue = useMemo(() => ({ state, dispatch, checkAndAddCart }), [state, dispatch]);

  return <CartContext.Provider value={cartProviderValue}>{children}</CartContext.Provider>;
};
